import { Layout } from "antd";
import React from "react";
import { Helmet } from "react-helmet";
import {
  Route,
  Switch,
  Redirect,
  useParams,
  useLocation,
} from "react-router-dom";
import NewEvent from "./NewEvents";
import PreviousEvent from "./PreviousEvents";
import DashboardContest from "../../../../pages/contest/dashboard";
import LeaderboardContest from "../../../../pages/contest/leaderboard";

const TITLE = "Contest | IUX Markets";

const isValidPath = (path) => {
  const validPaths = [
    /^\/[a-z]{2}\/wallet\/contest\/new-events$/,
    /^\/[a-z]{2}\/wallet\/contest\/new-events\/[\w-]+$/,
    /^\/[a-z]{2}\/wallet\/contest\/previous-events$/,
    /^\/[a-z]{2}\/wallet\/contest\/previous-events\/[\w-]+$/,
  ];

  return validPaths.some((pattern) => pattern.test(path));
};

const PathValidator = ({ children }) => {
  const location = useLocation();
  const { lang } = useParams();

  const isValidLang = /^[a-z]{2}$/.test(lang);

  if (!isValidLang || !isValidPath(location.pathname)) {
    return <Redirect to={`/${lang}/wallet/contest/new-events`} />;
  }

  return children;
};

const Dashboard = () => {
  const { id, lang } = useParams();
  const contestId = localStorage.getItem("contestId");

  if (!id || !contestId || !contestId.includes(id)) {
    return <Redirect to={`/${lang}/wallet/contest/new-events`} />;
  }

  return <DashboardContest />;
};

const Leaderboard = () => {
  const { id, lang } = useParams();
  const contestId = localStorage.getItem("contestId");

  if (!id || !contestId || !contestId.includes(id)) {
    return <Redirect to={`/${lang}/wallet/contest/previous-events`} />;
  }

  return <LeaderboardContest />;
};

const Contest = () => {
  return (
    <div>
      <Layout
        style={{
          padding: "24px 0px",
          position: "relative",
          maxWidth: "1160px",
        }}
      >
        <Helmet>
          <title>{TITLE}</title>
        </Helmet>
        <div className="bg-white" style={{ borderRadius: 20 }}>
          <>
            <div className="pb-4">
              <PathValidator>
                <Switch>
                  <Route
                    path={"/:lang/wallet/contest/new-events"}
                    exact
                    render={() => {
                      return <NewEvent />;
                    }}
                  />
                  <Route
                    path={"/:lang/wallet/contest/new-events/:id"}
                    exact
                    render={() => {
                      return <Dashboard />;
                    }}
                  />
                  <Route
                    path={"/:lang/wallet/contest/previous-events"}
                    exact
                    render={() => {
                      return <PreviousEvent />;
                    }}
                  />
                  <Route
                    path={"/:lang/wallet/contest/previous-events/:id"}
                    exact
                    render={() => {
                      return <Leaderboard />;
                    }}
                  />
                  <Route
                    path="*"
                    render={() => {
                      return (
                        <Redirect to={`/:lang/wallet/contest/new-events`} />
                      );
                    }}
                  />
                </Switch>
              </PathValidator>
            </div>
          </>
        </div>
      </Layout>
    </div>
  );
};

export default Contest;
